var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "billing-address-form" }, [
    _c("div", { staticClass: "container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form" },
        [
          _vm.form.isCompany
            ? _c(
                "div",
                { staticClass: "column" },
                [
                  _c("Input", {
                    attrs: { placeHolder: "John", title: "Şirket Adı" },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "column" },
                [
                  _c("Input", {
                    attrs: { placeHolder: "John", title: "Adı" },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                  _vm._v(" "),
                  _c("Input", {
                    attrs: { placeHolder: "Doe", title: "Soyadı" },
                    model: {
                      value: _vm.form.surname,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "surname", $$v)
                      },
                      expression: "form.surname",
                    },
                  }),
                ],
                1
              ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "column" },
            [
              !_vm.form.isCompany
                ? _c("Input", {
                    attrs: { placeHolder: "00000000000", title: "TC Kimlik" },
                    model: {
                      value: _vm.form.idenity,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "idenity", $$v)
                      },
                      expression: "form.idenity",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("Input", {
                attrs: { placeHolder: "johndoe@supsis.com", title: "E-Posta" },
                model: {
                  value: _vm.form.mail,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "mail", $$v)
                  },
                  expression: "form.mail",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.isCompany
            ? _c(
                "div",
                { staticClass: "column" },
                [
                  _c(
                    "div",
                    { attrs: { id: "input" } },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("a-auto-complete", {
                        staticStyle: { width: "100%" },
                        attrs: { "data-source": _vm.taxOffices },
                        on: { search: _vm.onSearch },
                        model: {
                          value: _vm.form.taxOffice,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "taxOffice", $$v)
                          },
                          expression: "form.taxOffice",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("Input", {
                    attrs: {
                      placeHolder: "00000000000",
                      title: "Vergi Numarası",
                    },
                    model: {
                      value: _vm.form.taxNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "taxNumber", $$v)
                      },
                      expression: "form.taxNumber",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "column" },
            [
              _c("Input", {
                attrs: { placeHolder: "Türkiye", title: "Ülke" },
                model: {
                  value: _vm.form.country,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "country", $$v)
                  },
                  expression: "form.country",
                },
              }),
              _vm._v(" "),
              _c("Input", {
                attrs: { placeHolder: "İstanbul", title: "Şehir" },
                model: {
                  value: _vm.form.city,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "city", $$v)
                  },
                  expression: "form.city",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("Input", {
            attrs: { placeHolder: "TeknoPark", title: "Adress" },
            model: {
              value: _vm.form.address,
              callback: function ($$v) {
                _vm.$set(_vm.form, "address", $$v)
              },
              expression: "form.address",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "billing-addreses-type" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.isCompany,
                  expression: "form.isCompany",
                },
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.form.isCompany)
                  ? _vm._i(_vm.form.isCompany, null) > -1
                  : _vm.form.isCompany,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.form.isCompany,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(_vm.form, "isCompany", $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.form,
                          "isCompany",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.form, "isCompany", $$c)
                  }
                },
              },
            }),
            _vm._v(" "),
            _c("label", [_vm._v("Şirket Faturası olarak kayıt et")]),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [_vm._v("Fatura Adresi")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("label", [_vm._v("Vergi Dairesi")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }